import React, { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import "./demo.css";

const slides = [
  {
    type: "video",
    src: "./images/video.mp4",
    title: "MacBook Neo",
  },
  {
    type: "image",
    desktopSrc: "./images/3.png",
    mobileSrc: "./images/4.png",
    title: "Ultra Thin Design",
  },
];

const Demo = () => {
  const panelsRef = useRef([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    gsap.set(panelsRef.current[1], {
      opacity: 0,
      y: 100,
    });

    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    let current = 0;
    let animating = false;

    const handleWheel = (e) => {
      if (animating) return;

      // Scroll Down
      if (e.deltaY > 0 && current === 0) {
        animating = true;

        gsap.to(panelsRef.current[0], {
          opacity: 0,
          scale: 0.9,
          duration: 0.8,
        });

        gsap.to(panelsRef.current[1], {
          opacity: 1,
          y: 0,
          duration: 0.8,
          onComplete: () => {
            current = 1;
            animating = false;
          },
        });
      }

      // Scroll Up
      if (e.deltaY < 0 && current === 1) {
        animating = true;

        gsap.to(panelsRef.current[1], {
          opacity: 0,
          y: 100,
          duration: 0.8,
        });

        gsap.to(panelsRef.current[0], {
          opacity: 1,
          scale: 1,
          duration: 0.8,
          onComplete: () => {
            current = 0;
            animating = false;
          },
        });
      }
    };

    window.addEventListener("wheel", handleWheel, { passive: true });

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);

  return (
    <section className="showcase">
      <div className="showcase-container">
        {slides.map((item, index) => (
          <div
            key={index}
            className="panel"
            ref={(el) => (panelsRef.current[index] = el)}
          >
            {item.type === "video" ? (
              <video
                src={item.src}
                autoPlay
                muted
                loop
                playsInline
                className="media"
              />
            ) : (
              <img
                src={isMobile ? item.mobileSrc : item.desktopSrc}
                alt={item.title}
                className="media"
              />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Demo;